import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Spin } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import * as Styled from '../../components/styled';
import Footer from "screens/Giftcard/components/Footer";

/**
 * 
 * @param {*} props 
 * @returns 
 */
const Order = (props) => {
  const [loading, setLoading] = useState(false) //eslint-disable-line
  const [error, setError] = useState(false)

  useEffect(() => {
    const result = props.match.params.result;
    if (result === 'fail') {
      setError(true)
    } else {
      setError(false)
    }
  }, []) // eslint-disable-line

  return (
    <div>
      <Styled.StyledWrapper>
        {
          loading ? (
            <Spin />
          ) : (
            <>
              {
                error ? (
                  <div style={{ textAlign: 'center' }}>
                    <h1 style={{ textAlign: 'center' }}>Une erreur est survenue</h1>
                    
                    <Link to={`/giftcard`} style={{ padding: 10, color: 'black', fontSize: 14, marginBottom: 10, textAlign: 'center'  }}>Cliquez ici pour essayer à nouveau</Link>
                  </div>
                ) : (
                  <>
                    <h1 style={{ textAlign: 'center' }}>Paiement reçu !</h1>
                    <div style={{ padding: 10, color: 'black', fontSize: 14, marginBottom: 10  }}>Merci pour votre achat, un mail de confirmation vous a été envoyé, il contient le lien de téléchargement de votre cadeau</div>
                    <div style={{ padding: 10, color: 'black', fontSize: 14, marginBottom: 10  }}>Selon vos préférences lors de votre achat, un mail a également été envoyé à l'adresse de destination que vous avez indiqué</div>
                    <Footer />
                  </>
                )
              }
            </>
          )
        }

      </Styled.StyledWrapper>
    </div>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

export default connect(stateToProps)(withTranslation()(Order));